import React from "react";
import { SvgIcon } from "@material-ui/core";

const DuplicateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M11.6667 3.66602H1V15.666H11.6667V3.66602Z"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3 1H14.3333V14.3333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.6665 7H8.99984"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.6665 9.66602H8.99984"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.6665 12.334H6.33317"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};

export default DuplicateIcon;
